import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=01c5b52e&scoped=true&"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js&"
import style0 from "./YoutubePlayer.vue?vue&type=style&index=0&id=01c5b52e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5b52e",
  null
  
)

export default component.exports